<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <form :id='formId'>
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.group.groupName')}}:</div>
              <input id="groupName" class="e-input e-input-group" maxLength="25" name="groupName" v-model="groupName"
                     :placeholder="$t('Security.group.groupName')" @keydown="stopEvent" @blur="checkGroupName"/>
            </div>
            <div class="error"></div>
          </div>
        </form>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.User.desc')}}:</div>
        <ejs-textbox id="description" name="Description" maxLength="50" v-model="description" :multiline="true"/>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <ejs-grid :dataSource="userData" ref="grid" height='380px' :dataBound='dataBound'>
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="userId" :visible="false" :isPrimaryKey="true"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="realName" :headerText="$t('Security.User.realname')" width="120" textAlign="Center"></e-column>
            <e-column field="statusName" :headerText="$t('Security.User.status')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: "modifyGroup",
  props: {
    formId: String
  },
  data() {
    return {
      groupId: '',
      groupName: '',
      description: '',
      userData: [],
      selectedUser: [],
      selectIndexes: [],
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      validateOptions: {
        customPlacement: function(inputElement, errorElement) {
          inputElement = inputElement.closest('.form-group').querySelector('.error');
          inputElement.parentElement.appendChild(errorElement);
        },
        rules: {
          'groupName': {
            required: [true, `${this.$t('Security.group.groupName')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          }
        }
      }
    }
  },
  methods: {
    init() {
      this.formValidator = new FormValidator('#'+this.formId, this.validateOptions);
    },
    queryUserList() {
      const url = '/lte/ems/user/findAccountList';
      const That = this;
      this.axios.get(url, {}).then(response => {
        const result = response.data;
        result.forEach((item, index) => {
          item.createTime = new Date(item.createTime);
          if(That.selectedUser.indexOf(item.userId) > -1) {
            That.selectIndexes.push(index)
          }
        });
        That.userData = result;
      });
    },
    findEditGroup(groupId) {
      const url = '/lte/ems/group/findOne';
      const That = this;
      this.axios.get(url, {params: {groupId:groupId}}).then(response => {
        let result = response.data;
        if (result!=null) {
          That.groupId = result.groupId;
          That.groupName = result.groupName;
          That.description = !!result.description?result.description:'';
          if(result.accountIdList!=null && result.accountIdList.length>0){
            result.accountIdList.forEach((item, index) => {
              That.selectedUser.push(item)
            });
          }
        }
        That.queryUserList();
      });
    },
    getParams() {
      let records = this.$refs.grid.getSelectedRecords();
      let ids = [];
      records.forEach(user => {
        ids.push(user.userId)
      });
      return {
        groupId: this.groupId,
        groupName: this.groupName,
        description: this.description,
        accountIdList: ids
      }
    },
    validate() {
      return this.formValidator.validate();
    },
    checkGroupName() {
      this.groupName = this.groupName.trim();
    },
    dataBound() {
      this.$refs.grid.selectRows(this.selectIndexes, false);
    },
    stopEvent(event) {
      if (event.keyCode == 13) {
        event.cancelBubble = true;
        event.returnValue = false;
        return false;
      }
    }
  }
}
</script>

<style scoped>

</style>
